import { useSelector } from 'react-redux'
import { QUICK_NAVIGATION } from '../constant'
import { useNavigate } from 'react-router-dom'
import { useMemo } from 'react'
import { getUserInfo } from '../../../globalUtils/commonUtills'

export const useQuickNavigation = (navItems) => {
  const navigate = useNavigate()
  const getUserProfile = useSelector((state) => getUserInfo(state))
  const handleNavigation = (path) => {
    if (/^(?:[a-z]+:)?\/\//i.test(path)) {
      window.location.href = path
    } else {
      navigate(path)
    }
  }
  const navigationItems = useMemo(() => {
    if (!getUserProfile) {
      return []
    }
    const items = navItems || QUICK_NAVIGATION
    const userRoles = getUserProfile.roles || []

    return items.filter(
      (feature) =>
        feature.enabled === true ||
        (Array.isArray(feature.enabled) &&
          userRoles.some((role) => feature.enabled.includes(role))),
    )
  }, [getUserProfile, navItems])

  return {
    navigationItems,
    handleNavigation,
  }
}
